export const DOMAIN = process.env.REACT_APP_DOMAIN || "-dev.agyo.io";
export const ENV = process.env.REACT_APP_ENV || "dev";

let enableLogs = true;
if (process.env.REACT_APP_ENABLE_CONSOLE_LOGS === "false") {
    enableLogs = false;
}

export const ENABLE_CONSOLE_LOGS = enableLogs;
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost";
export const WORKSPACE_READ_API_URL = process.env.REACT_APP_WORKSPACE_READ_API_URL || "http://localhost";
export const WORKSPACE_WRITE_API_URL = process.env.REACT_APP_WORKSPACE_WRITE_API_URL || "http://localhost";

export const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const TS_DIGITAL_IMAGES =
    process.env.REACT_APP_TS_DIGITAL_IMAGES || "https://appdev.teamsystemdigital.com/images/ts-digital/";
